document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelectorAll('.faq__item');

  button.forEach(btn => {
    btn.addEventListener('click', () => {
      const faqItem = btn.closest('.faq__item');
      faqItem.classList.toggle('active');
    });
  });
});
